"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TicketHeader = TicketHeader;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mixinConstants = require("../constants/mixinConstants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function TicketHeader(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ticket__header ticket__header--".concat(size)
  }, children);
}

TicketHeader.propTypes = {
  children: _propTypes["default"].node.isRequired,
  size: _propTypes["default"].oneOf(_mixinConstants.sizes)
};
TicketHeader.defaultProps = {
  size: 'is-one-fifth'
};